import { render, staticRenderFns } from "./TaxRevenueRule.vue?vue&type=template&id=7837b472&scoped=true"
import script from "./TaxRevenueRule.vue?vue&type=script&lang=js"
export * from "./TaxRevenueRule.vue?vue&type=script&lang=js"
import style0 from "./TaxRevenueRule.vue?vue&type=style&index=0&id=7837b472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7837b472",
  null
  
)

export default component.exports